import { render, staticRenderFns } from "./GoogleIcon.vue?vue&type=template&id=5a688246&scoped=true"
import script from "./GoogleIcon.vue?vue&type=script&lang=js"
export * from "./GoogleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a688246",
  null
  
)

export default component.exports